/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'course-set': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M870.22 177.729L340.567 831.738l-13.357 191.75H.256V0H870.22v177.729zm0 569.213v276.546H646.283L870.22 746.942zM102.606 204.698v102.348h511.744V204.698H102.605zm0 204.697v102.35H409.65v-102.35H102.605zm469.064 543.626L415.383 1024l36.948-167.596 450.846-556.778 119.339 96.617-450.847 556.778z" _fill="#cdcdcd"/>'
  }
})
